import React, { useState } from "react";
import "./Payroll.css";
import MobileLayout from "../../../layouts/MobileLayout";

const PayrollPage = () => {
  const [activeTab, setActiveTab] = useState("payslips");

  // Dummy data (replace with API response)
  const payslips = [
    {
      id: 1,
      month: "March 2026",
      uploaded: "25 March 2026",
      gross: "₹85,000",
      net: "₹64,450",
    },
    {
      id: 2,
      month: "February 2026",
      uploaded: "25 Feb 2026",
      gross: "₹85,000",
      net: "₹67,200",
    },
  ];

  return (
    <MobileLayout>
      
    {/* <div className="payroll-page">
      
      <div className="payroll-tabs">
        <button
          className={activeTab === "payslips" ? "tab active" : "tab"}
          onClick={() => setActiveTab("payslips")}
        >
          My Payslips
        </button>

        <button
          className={activeTab === "tax" ? "tab active" : "tab"}
          onClick={() => setActiveTab("tax")}
        >
          My Tax sheets
        </button>
      </div>

      
      {activeTab === "payslips" && (
        <div className="payslip-list">
          {payslips.map((item) => (
            <div className="payslip-card" key={item.id}>
              <div className="payslip-titles">{item.month}</div>

              <div className="upload-date">
                Uploaded {item.uploaded}
              </div>

              <div className="salary-row">
                <div className="salary-col">
                  <span className="label">Gross</span>
                  <span className="values">{item.gross}</span>
                </div>

                <div className="divider" />

                <div className="salary-col">
                  <span className="label">Net Pay</span>
                  <span className="values">{item.net}</span>
                </div>

                <div className="divider" />

                <button className="view-btns">
                  View
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {activeTab === "tax" && (
        <div className="empty-state">
          No tax sheets available.
        </div>
      )}
    </div> */}

    </MobileLayout>


  );
};

export default PayrollPage;